import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { List, ListItem } from '@mui/material';
import { withStyles } from '@mui/styles';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEnoughPermissions } from '../../utils';

const styles = {
    button: {
        '&.active': {
            backgroundColor: 'rgba(0, 0, 0, 0.08)'
        }
    }
};

const AdapterNavLink = React.forwardRef((props, ref) => (
    <NavLink
        ref={ref}
        {...props}
    />
));

const DrawerReportsPanel = props => {
    const { classes, model } = props;
    const { t } = useTranslation();

    const menuItems = [
        { translateId: 'archive', routeTo: '/reports/archive' },
        { translateId: 'deviceAssignmentReport', routeTo: '/reports/device-assignment-report' },
        { translateId: 'deviceUnassignmentReport', routeTo: '/reports/device-unassignment-report' },
        { translateId: 'expenseReport', routeTo: '/reports/expense-report' },
        { translateId: 'orderingReport', routeTo: '/reports/ordering-report' },
        { translateId: 'eisEcReports', routeTo: '/reports/eis-ec-reports' },
        { translateId: 'licensesPaymentsReport', routeTo: '/reports/licenses-payments-report' }
    ];

    const currentUserPerms = model?.permissions || [];
    const filteredMenuItems = menuItems.filter(item => isEnoughPermissions(item, currentUserPerms));
    return (
        <List>
            {filteredMenuItems.map(item => (
                <ListItem
                    key={filteredMenuItems.indexOf(item)}
                    button
                    className={classes.button}
                    component={AdapterNavLink}
                    to={item.routeTo}
                >
                    {t(item.translateId)}
                </ListItem>
            ))}
        </List>
    );
};

DrawerReportsPanel.propTypes = {
    classes: PropTypes.shape({
        button: PropTypes.string,
    }),
    model: PropTypes.shape({
        permissions: PropTypes.arrayOf(PropTypes.string),
    }),
};

const mapStateToProps = ({ user }) => ({
    model: user.model
});

export default compose(connect(mapStateToProps), withStyles(styles))(DrawerReportsPanel);
